module.exports = __webpack_public_path__ + "img/badge-highest-lead-quality-bronze.5e36e0b4.png";